import styles from "./index.module.css";
import { ThreeDots } from "react-loader-spinner";
import { useSelector } from "react-redux";

const Loader = () => {
  const secondaryColor = useSelector(
    (state) => state.local.uiConfig.secondary.main,
  );

  return (
    <div className={styles.container}>
      <ThreeDots
        height="80"
        width="80"
        radius="9"
        color={secondaryColor}
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={true}
      />
    </div>
  );
};
export default Loader;
